var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtImg',{staticClass:"align-baseline shadow",attrs:{"preload":"","provider":"storyblok","width":"18","height":"16","src":"https://a.storyblok.com/f/118728/x/8896bea3df/id.svg","alt":"bendera indonesia"}})
}
var staticRenderFns = []

export { render, staticRenderFns }